<template>
  <div v-if="isActiveMember">
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-row>
          <v-col cols="12" sm="5" md="6">
            <v-card class="pa-8 elevation-0 rounded-lg hover-shadow fill-height mitra-card">
              <div class="d-block mb-5">
                <v-skeleton-loader
                  v-bind="attrs"
                  type="image"
                  class="fill-height"
                ></v-skeleton-loader>
              </div>

              <div class="d-block mt-5">
                <v-skeleton-loader
                  v-bind="attrs"
                  type="image"
                  class="fill-height"
                ></v-skeleton-loader>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="7" md="6">
            <v-card class="pa-8 elevation-0 rounded-lg hover-shadow fill-height mitra-card">
              <v-skeleton-loader
                v-bind="attrs"
                type="list-item, list-item, list-item, list-item, list-item, list-item, list-item, list-item"
                class="fill-height"
              ></v-skeleton-loader>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    props: ['isActiveMember', 'networkType'],
    data() {
      return {
        attrs: {
          class: '',
          boilerplate: true,
          elevation: 2,
        },
      }
    },
  }
</script>